<template>

  <div class="container mx-aut">
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" finishButtonText="Finalizar" backButtonText="Anterior" nextButtonText="Siguiente"
          @on-complete="createProject" ref="wizard" @on-change="scrollUp" style="height: 970px;">

          <h2 class="custom-title" slot="title">Crear proceso</h2>
          <h3 class="custom-title subtitle" slot="title">Por favor llena todos los campos</h3>

        <!-- Paso 1 -->
        <tab-content title="Información del candidato" class="mb-5" icon="feather icon-user" :before-change="validateStep1" >
          <form autocomplete="off" data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label class="form-labels" for="">Nombres</label>
                <vs-input id="firstNameCandidate" v-model="project.first_name" @keypress="regExpressionText" class="w-full" name="project.first_name" maxlength="50" v-validate="'max:50|required'" />
                <span class="text-danger" v-show="errors.has('project.first_name')">Requerido</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label class="form-labels" for="">Apellidos</label>
                <vs-input id="lastNameCandidate" v-model="project.last_name" @keypress="regExpressionText" class="w-full" name="project.last_name" maxlength="50" v-validate="'max:50|required'" />
                <span class="text-danger" v-show="errors.has('project.last_name')">Requerido</span>
              </div>

              <div style="-webkit-margin-before:1.4%;" class="vx-col md:w-1/2 w-full mt-8">
                <label class="vs-select--label form-labels" for="">Tipo de documento</label>
                <v-select style="-webkit-margin-before:0% !important;" :options="idTypes" :reduce="city => city.id" v-model="project.person_id_type" placeholder="Seleccione una opción" class="w-full select-large mt-5" label="label"
                    id="project.person_id_type" name="project.person_id_type" v-validate="'required'">
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('project.person_id_type')">Requerido</span>
              </div>
              <!--El input cambia -->
              <div class="vx-col md:w-1/2 w-full mt-8">
                <label class="form-labels" for="">Número de documento</label>
                <vs-input v-if="project.person_id_type > 2" @keypress="onlyText" @paste="onPaste" id="project.person_id" v-model="project.person_id" class="w-full" name="project.person_id"
                    v-validate="'min:5|required|alpha_num'" />
                <vs-input v-else @keypress="onlyText" @paste="onPaste" id="project.person_id" v-model="project.person_id" class="w-full" name="project.person_id"
                    v-validate="'min:5|required|numeric'"/>
                <span class="text-danger" v-show="errors.has('project.person_id')">Requerido</span>
              </div>

              <div class="vx-col md:w-1/2 w-full mt-6">
                <label class="form-labels" for="">Email</label>
                <vs-input id="emailCandidate" v-model="project.email_1" class="w-full" name="project.email_1" v-validate="'required|email'" />
                <span class="text-danger" v-show="errors.has('project.email_1')">Requerido</span>
              </div>

              <div style="-webkit-margin-before:1.6%;" class="vx-col md:w-1/2 w-full">
                <label class="vs-select--label form-labels" for="">Nivel educativo</label>
                <v-select style="-webkit-margin-before:0% !important;" id="selectCountry" :options="educationLevels" :reduce="level => level.id" v-model="project.education_level" placeholder="Nivel educativo" class="w-full select-large mt-5" label="label"
                  name="project.education_level" v-validate="'required'">
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('project.education_level')">Requerido</span>
              </div>

              <div style="-webkit-margin-before:1.4%;" class="vx-col md:w-1/2 mt-6">
                <label class="vs-select--label form-labels" for="">Indicativo</label>
                <v-select style="-webkit-margin-before:0% !important;" :options="dialingCodes" v-model="project.dialing_code_1" :reduce="option => option.value" placeholder="Seleccione una opción" class="w-full select-large mt-5" label="label"
                    id="dialing_code_1" name="project.dialing_code_1" v-validate="'required'">
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('project.dialing_code_1')">Requerido</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-6">
                <label class="form-labels" for="">Celular</label>
                <vs-input id="phoneCandidate" v-model="project.telephone_1" class="w-full" name="project.telephone_1" v-validate="'min:10|required|numeric'"  maxlength="10"/>
                <span class="text-danger" v-show="errors.has('project.telephone_1')">Requerido (solo caracteres númericos de 10 dígitos)</span>
              </div>

            </div>
            <div class="vx-row mt-3 pb-2">
              <div style="-webkit-margin-before:1.6%;" class="vx-col md:w-1/2 w-full">
                <label class="vs-select--label form-labels" for="">País</label>
                <v-select style="-webkit-margin-before:0% !important;" id="selectCountry" :options="countries" :reduce="country => country.id" v-model="country_id" placeholder="Seleccionar país" class="w-full select-large mt-5" label="name"
                    name="country_id" v-validate="'required'">
                </v-select>
              </div>
              <div style="-webkit-margin-before:1.6%;" class="vx-col md:w-1/2 w-full">
                <label class="vs-select--label form-labels" for="">Ciudad</label>
                <v-select style="-webkit-margin-before:0% !important;" id="selectCity" :options="cities" :reduce="city => city.id" v-model="project.city_id" placeholder="Seleccionar ciudad" class="w-full select-large mt-5" label="name"
                    name="project.city_id" v-validate="'required'">
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('project.city_id')">Requerido</span>
              </div>
            </div>
          </form>
        </tab-content>

        <!-- Paso 2 -->
        <tab-content title="Información del proceso" class="mb-5" icon="feather icon-clipboard" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <products :contract_id.sync="contract_id" :productsProject.sync="productsProject" />
            </div>

            <div v-if="productsProject!= null && [13,6,12,15,18].includes(productsProject[0])" class="vx-row">
              <div class="vx-col md:w-1/1 w-full md:mt-8">
                <div class="demo-alignment">
                  <div class="flex" style="flex-direction:column;">
                    <span style="font-size:18px;">Selecciona el formato de la visita</span>
                    <vs-radio v-model="projectIsVirtual" :vs-value="false" vs-name="is-virtual" name="project.projectIsVirtual" v-validate="'required'">
                      Hacer la visita presencial
                    </vs-radio>
                    <vs-radio v-model="projectIsVirtual" :vs-value="true" vs-name="is-virtual" name="project.projectIsVirtual" v-validate="'required'">
                      Hacer la visita virtual
                    </vs-radio>
                    <span class="text-danger" v-show="errors.has('project.projectIsVirtual')">Requerido</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row">
              <hr />
            </div>

            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full mt-5">
                <vs-input id="chargeToApply" label="Cargo aspirante / colaborador" @keypress="regExpressionTextNumbers" v-model="project.current_activity" class="w-full" name="project.current_activity" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('project.current_activity')">Requerido</span>
              </div>
            </div>

            <div class="vx-row" v-if="hasBusinessUnits">
              <div class="vx-col md:w-1/1 w-full mt-5">
                  <vs-select id="selectBusinessUnit" v-model="businessUnit" label="Empresa contratante *" name="businessUnit" class="w-full select-large mt-5">
                    <vs-select-item v-for="(unit, index) in businessUnitOptions" :key="index" :value="unit.id" :text="unit.name" class="w-full"/>
                  </vs-select>
                <span class="text-danger text-sm" v-show="businessUnitError">{{ businessUnitRequiredMessage }}</span>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full mt-5">
                <vs-input id="billingCenter" label="Centro de costo" @keypress="regExpressionTextNumbers" v-model="project.billing_center" class="w-full" name="project.billing_center" />
                <span class="text-danger text-sm" v-show="errors.has('project.billing_center')">Requerido</span>
              </div>
            </div>
          </form>
        </tab-content>

        <!-- Paso 3 -->
        <tab-content title="Información Adicional" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep3" >
          <form data-vv-scope="step-3" class="step-additional-info">
            <header class="step-additional-info__intro">
              <h3 class="step-additional-info__intro-title">Complementa tu solicitud</h3>
              <p class="step-additional-info__intro-text">
                Estos datos ayudan a ejecutar las validaciones del proceso. Completa solo lo que aplique; los campos opcionales pueden dejarse en blanco.
              </p>
            </header>

            <section
              class="additional-info-card"
              aria-labelledby="additional-info-purpose-title"
            >
              <header class="additional-info-card__header">
                <span class="additional-info-card__icon" aria-hidden="true">
                  <feather-icon icon="TargetIcon" svgClasses="h-5 w-5 stroke-current" />
                </span>
                <div class="additional-info-card__heading">
                  <h4 id="additional-info-purpose-title" class="additional-info-card__title">
                    Propósito del proceso
                  </h4>
                  <p class="additional-info-card__subtitle">
                    Selección es para procesos de contratación. Elige Actualización si validas empleados actuales o riesgo periódico. Esto cambia el mensaje que recibe la persona.
                  </p>
                </div>
              </header>

              <div class="additional-info-card__body">
                <div class="additional-info-radio-group">
                  <vs-radio
                    v-model="project.purpose"
                    vs-value="selection"
                    vs-name="project-purpose"
                    name="project.purpose"
                    v-validate="'required'"
                  >
                    Selección
                  </vs-radio>
                  <vs-radio
                    v-model="project.purpose"
                    vs-value="actualization"
                    vs-name="project-purpose"
                    name="project.purpose"
                  >
                    Actualización
                  </vs-radio>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('project.purpose')">Requerido</span>
              </div>
            </section>

            <div v-if="productsProject == 4" class="step-additional-info__section">
              <PoligraphyCards
                :formFailed="formFailed"
                @on-form-failure="handleFormFailure"
                @update-poligraph-date-second="handlePoligraphDateSecondUpdate"
                @update-poligraph-date="handlePoligraphDateUpdate"
                @update-poligraph-reason="handlePoligraphReasonUpdate"
                @update-poligraphy-type="handlePoligraphyTypeUpdate"
                @update-poligraph-virtual="handlePoligraphVirtualUpdate"
                @update-form-validity="handleFormValidityUpdate"
              />
            </div>

            <section
              v-if="requiresAntecedentes"
              class="additional-info-card"
              aria-labelledby="additional-info-antecedentes-title"
            >
              <header class="additional-info-card__header">
                <span class="additional-info-card__icon" aria-hidden="true">
                  <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 stroke-current" />
                </span>
                <div class="additional-info-card__heading">
                  <h4 id="additional-info-antecedentes-title" class="additional-info-card__title">
                    Antecedentes y documento de identidad
                  </h4>
                  <p class="additional-info-card__subtitle">
                    La fecha de expedición permite consultar fuentes oficiales asociadas al documento del candidato.
                  </p>
                </div>
              </header>

              <div class="additional-info-card__body">
                <div class="expedition-date-layout">
                  <div class="expedition-date-layout__input">
                    <label class="additional-info-field__label" for="identificationExpeditionDate">
                      Fecha de expedición del documento
                      <span class="additional-info-field__recommended">Recomendado</span>
                    </label>
                    <vs-input
                      id="identificationExpeditionDate"
                      :value="identificationExpeditionDateText"
                      placeholder="DD/MM/AAAA"
                      maxlength="10"
                      :danger="showInvalidExpeditionDateWarning"
                      class="w-full mt-2"
                      @input="onExpeditionDateTextInput"
                      @blur="onExpeditionDateTextBlur"
                      @keypress="expeditionDateKeypress"
                      @paste.native="onExpeditionDatePaste"
                    />
                    <p class="expedition-date-help mt-2">
                      Escribe o pega la fecha (ej. 31/05/2007).
                    </p>
                  </div>

                  <div class="expedition-date-layout__calendar">
                    <p class="expedition-date-calendar-label">Calendario</p>
                    <datepicker
                      v-model="identificationExpeditionDatePicker"
                      :language="languages[datepickerLanguage]"
                      format="dd/MM/yyyy"
                      inline
                      name="identification_expedition_date_picker"
                      class="expedition-date-picker expedition-date-picker--inline w-full"
                      @selected="onExpeditionDatePicked"
                    />
                  </div>
                </div>

                <div
                  v-if="showMissingExpeditionDateWarning"
                  class="expedition-date-warning mt-4"
                  role="alert"
                >
                  <span class="expedition-date-warning__icon" aria-hidden="true">!</span>
                  <div class="expedition-date-warning__body">
                    <p class="expedition-date-warning__text">
                      Sin esta fecha no podremos consultar las siguientes fuentes de antecedentes:
                    </p>
                    <ul
                      v-if="expeditionDateRequiredSourceLabels.length"
                      class="expedition-date-warning__sources"
                    >
                      <li
                        v-for="(sourceLabel, sourceIndex) in expeditionDateRequiredSourceLabels"
                        :key="'expedition-source-' + sourceIndex"
                      >
                        {{ sourceLabel }}
                      </li>
                    </ul>
                    <p class="expedition-date-warning__text expedition-date-warning__cta">
                      Ingrésala ahora para que se consulten todas las fuentes.
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="showInvalidExpeditionDateWarning"
                  class="expedition-date-error mt-4"
                  role="alert"
                >
                  <span class="expedition-date-error__icon" aria-hidden="true">!</span>
                  <p class="expedition-date-error__text">
                    La fecha debe estar en formato DD/MM/AAAA y ser válida (por ejemplo 31/05/2007).
                  </p>
                </div>
              </div>
            </section>

            <section
              class="additional-info-card"
              aria-labelledby="additional-info-viaticos-title"
            >
              <header class="additional-info-card__header">
                <span class="additional-info-card__icon" aria-hidden="true">
                  <feather-icon icon="DollarSignIcon" svgClasses="h-5 w-5 stroke-current" />
                </span>
                <div class="additional-info-card__heading">
                  <h4 id="additional-info-viaticos-title" class="additional-info-card__title">
                    Viáticos
                  </h4>
                  <p class="additional-info-card__subtitle">
                    Indica si el proceso requiere cubrir gastos de desplazamiento del candidato.
                  </p>
                </div>
              </header>

              <div class="additional-info-card__body">
                <div class="additional-info-checkbox-row">
                  <vs-checkbox id="allowanceAuthorization" v-model="project.allowance_authorization">
                    Autorizo el pago de viáticos para este proceso
                  </vs-checkbox>
                </div>
                <div
                  v-if="project.allowance_authorization"
                  class="additional-info-field additional-info-field--indented mt-4"
                >
                  <vs-input
                    id="travelAllownce"
                    label="Cantidad de viáticos"
                    v-model="project.travel_allowance"
                    class="w-full"
                    name="travel_allowance"
                    type="text"
                    @keypress="onlyNumbers"
                    @paste="onlyNumbersOnPaste"
                  />
                </div>
              </div>
            </section>

            <section
              v-if="showCreditValidationSection"
              class="additional-info-card additional-info-card--accent"
              aria-labelledby="additional-info-datacredito-title"
            >
              <header class="additional-info-card__header additional-info-card__header--spread">
                <div class="additional-info-card__header-main">
                  <span class="additional-info-card__icon additional-info-card__icon--accent" aria-hidden="true">
                    <feather-icon icon="CreditCardIcon" svgClasses="h-5 w-5 stroke-current" />
                  </span>
                  <div class="additional-info-card__heading">
                    <h4 id="additional-info-datacredito-title" class="additional-info-card__title">
                      Centrales de riesgo
                    </h4>
                    <p class="additional-info-card__subtitle">
                      Verificación de historial crediticio a través de Datacrédito.
                    </p>
                  </div>
                </div>
                <img
                  class="additional-info-card__brand-icon"
                  :src="publicAssetUrl('Pdf/mha-clients-icons/Wallet.png')"
                  alt=""
                >
              </header>

              <div class="additional-info-card__body">
                <p class="additional-info-cost-notice" role="note">
                  <span class="additional-info-cost-notice__icon" aria-hidden="true">$</span>
                  <span>
                    La verificación en centrales de riesgo (Datacrédito) tiene un
                    <strong>costo adicional</strong> al valor del proceso.
                  </span>
                </p>
                <div class="additional-info-checkbox-row">
                  <vs-checkbox v-model="project.credit_validation">
                    Incluir verificación en centrales de riesgo (Datacrédito)
                  </vs-checkbox>
                </div>
              </div>
            </section>

            <section
              class="additional-info-card"
              aria-labelledby="additional-info-observations-title"
            >
              <header class="additional-info-card__header">
                <span class="additional-info-card__icon" aria-hidden="true">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 stroke-current" />
                </span>
                <div class="additional-info-card__heading">
                  <h4 id="additional-info-observations-title" class="additional-info-card__title">
                    Instrucciones del proceso
                  </h4>
                  <p class="additional-info-card__subtitle">
                    Comparte indicaciones especiales para el equipo que ejecutará las validaciones.
                  </p>
                </div>
              </header>

              <div class="additional-info-card__body">
                <vs-textarea
                  v-model="project.observations"
                  class="w-full additional-info-textarea"
                  name="project.observations"
                  maxlength="2500"
                  rows="4"
                  placeholder="Ej. priorizar referencias laborales, contactar solo por correo, etc."
                  v-validate="'max:2500'"
                  @keypress="regExpressionTextNumbers"
                />
                <p class="additional-info-char-hint">
                  Máximo 2.500 caracteres.
                </p>
                <span class="text-danger text-sm" v-show="errors.has('project.observations')">
                  La observación supera el límite permitido.
                </span>
              </div>
            </section>

            <!-- <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full md:mt-8">
                  <div class="flex">
                    <vs-checkbox id="allowanceAuthorization" v-model="contact_candidate"></vs-checkbox>
                    ¿Nos autorizas a solicitarle al candidato información sobre sus referencias académicas, laborales y personales? Esto optimiza el proceso, pues el candidato es el responsable de compartirnos los datos necesarios.
                  </div>
                </div>
              </div>
              <div class="vx-row" v-if="contact_candidate">
                <label for="" style="font-size:15px; margin-left: 1.5rem; margin-top: 2rem">Por favor ingresa el email y el celular del candidato</label>
              </div>
              <div class="vx-row" v-if="contact_candidate">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Email" id="emailCandidate" v-model="project.email_1" class="w-full" name="project.email_1" v-validate="'required|email'" />
                  <span class="text-danger" v-show="errors.has('project.email_1')">Requerido</span>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Celular" id="phoneCandidate" v-model="project.telephone_1" class="w-full" name="project.telephone_1" v-validate="'required|numeric'" maxlength="10"/>
                  <span class="text-danger" v-show="errors.has('project.telephone_1')">Requerido (solo caracteres númericos)</span>
                </div>
              </div> -->
          </form>
        </tab-content>

        <!-- Paso 4 -->
        <tab-content title="Documentos del candidato" class="mb-5" icon="feather icon-file" :before-change="validateStep3">
          <form data-vv-scope="step-4">
            <div class="files-candiate">
              <div class="list-documents">
                <vs-list>
                  <vs-list-header icon="format_list_numbered" title="Documentos necesarios para iniciar el proceso"></vs-list-header>
                  <ul>

                    <div  v-for="(type, typeFileIndex) in typeFiles" :key="type.id">
                      <div class="accordion-header" @click="toggleAccordion(typeFileIndex, false)">
                        <div class="item-document">
                          <div class="column">
                            <vs-button class="color-purple icon-add text-size" type="flat" :disabled="allowsNewFile(type.type_file)" @click.prevent="assignFile(type.type_file), toggleAccordion(typeFileIndex, true)" @click.stop>
                              <span class="material-icons item-icon">drive_folder_upload</span> {{ type.label }}
                            </vs-button>
                          </div>
                        <div class="column-2">
                          <span class="max-upload">Máximo {{ type.maxUploads }} {{ type.maxUploads == 1 ? 'archivo' : 'archivos'}}</span>
                        </div>
                          <vs-button class="icon-add" type="transparent" @click.prevent>
                            <span :id="`chevron${typeFileIndex}`" class="material-icons">expand_more</span>
                          </vs-button>
                        </div>

                        <div class="accordion-content" :id="`content${typeFileIndex}`">
                          <div  v-for="file in files" :key="file.input_id">
                              <span v-if="type.type_file === file.id">
                                <div v-if="file.content !== null" class="item-document">
                                    <div>
                                      <span class="material-icons item-icon color-green">check</span>
                                      <span v-if="file.name_upload.length < 30" class="text-size color-green" @click.stop> {{ file.name_upload }}</span>
                                      <span v-else class="text-size color-green" @click.stop> {{ file.name_upload.substring(0, 40) + '...' }}</span>
                                    </div>
                                    <vs-button class="item-icon" color="danger" type="flat" @click.prevent="clearInputsFile(file)" @click.stop><span class="material-icons item-icon">clear</span></vs-button>
                                </div>
                              </span>
                          </div>
                          <div v-if="noFilesAdded(typeFileIndex)" class="item-document">
                            <span class="no-added-files"> <span class="material-icons item-icon">info</span> No se han agregado archivos</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </ul>
                </vs-list>
                <div v-for="file in files" :key="file.input_id">
                  <input type="file" style="display: none;" :id="`inputFile${file.input_id}`" :ref="`inputFile${file.input_id}`" @change="preChargeFiles(file.input_id)" accept="image/png, image/jpg, image/jpeg, application/pdf"/>
                </div>
                <div v-show="this.non_valid_message" class="extension-error">
                  <p  class="extension-message">Solo se permite subir formatos en png, jpg, jpeg y pdf.</p>
                </div>
                <div v-show="this.non_valid_size" class="extension-error">
                  <p class="extension-message">El tamaño del archivo debe ser menor a 2 MB.</p>
                </div>
              </div>
            </div>
          </form>
        </tab-content>

        <div class="loader-create" v-if="showLoader">
          <Loader show="true" />
        </div>
      </form-wizard>

      <vs-popup
        title=""
        button-close-hidden
        :active.sync="expeditionDateOmissionModalActive"
        class="expedition-date-omission-popup"
      >
        <div
          class="expedition-date-omission"
          role="alertdialog"
          aria-labelledby="expedition-date-omission-title"
          aria-describedby="expedition-date-omission-lead"
        >
          <button
            type="button"
            class="expedition-date-omission__close"
            aria-label="Cerrar"
            @click="expeditionDateOmissionModalActive = false"
          >
            <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
          </button>

          <span class="expedition-date-omission__icon" aria-hidden="true">
            <feather-icon icon="AlertTriangleIcon" svgClasses="h-6 w-6" />
          </span>
          <h3 id="expedition-date-omission-title" class="expedition-date-omission__title">
            ¿Continuar sin la fecha de expedición?
          </h3>
          <p id="expedition-date-omission-lead" class="expedition-date-omission__lead">
            Sin la fecha de expedición del documento no podremos consultar estas fuentes de antecedentes:
          </p>

          <ul
            v-if="expeditionDateRequiredSourceLabels.length"
            class="expedition-date-omission__sources"
          >
            <li
              v-for="(sourceLabel, sourceIndex) in expeditionDateRequiredSourceLabels"
              :key="'expedition-omission-source-' + sourceIndex"
              class="expedition-date-omission__source"
            >
              {{ sourceLabel }}
            </li>
          </ul>

          <p class="expedition-date-omission__hint">
            Te recomendamos ingresarla ahora para que el proceso incluya todas las consultas.
          </p>

          <div class="expedition-date-omission__actions">
            <vs-button type="border" class="expedition-date-omission__button" @click="continueWithoutExpeditionDate">
              Continuar sin la fecha
            </vs-button>
            <vs-button class="expedition-date-omission__button" @click="goToExpeditionDateInput">
              Ingresar fecha
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>

</template>

<script>
import { publicAssetUrl } from '@/utils/publicAssets'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import * as datepickerLocales from 'vuejs-datepicker/src/locale';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import api from '../../../mixins/api'
import Products from './../../../components-globalwork/projects/Products.vue'
import { mapGetters, mapMutations } from 'vuex'
import validateFile from './../../../mixins/validateFile'
import Select from './../../../components/own-component/select-local'
import Loader from './../../../views/Loader.vue'
import PoligraphyCards from './../../../components-globalwork/projects/PoligraphyCards.vue';
export default {
  mixins: [api, validateFile],
  name: 'CreateProjects',
  props: {
    popupActive: Boolean
  },
  data() {
    return {
      formFailed: false,
      isFormValid: false,
      businessUnits: [],
      businessUnit: '',
      businessUnitError: false,
      businessUnitRequiredMessage: 'Debes seleccionar la empresa contratante para continuar',
      projectIsVirtual: null,

      showLoader: false,
      type_file: null,
      perPage: 10,
      page: 1,
      typeFiles:[
        {
          type_file: 0, name:'Hoja de vida', label: 'Subir Hoja de Vida *', maxUploads: 1
        },
        {
          type_file: 1, name: 'Habeas Data', label: 'Subir Habeas Data *', maxUploads: 1
        },
        {
          type_file: 2, name:'Diploma Academico', label: 'Subir Diploma Académico', maxUploads: 4
        },
        {
          type_file: 3, name: 'Certificado Academico', label: 'Subir Certificado Académico', maxUploads: 4
        },
        {
          type_file: 4, name: 'Certificado Laboral', label: 'Subir Certificado Laboral', maxUploads: 4
        }
      ],
      contract_id: null,
      productsProject: null,
      project: {
        dialing_code_1: "57",
        purpose: "selection"
      },
      antecedentesProjectTypeIds: [1, 2, 3, 4, 5, 7, 12, 13, 19, 20],
      datepickerLanguage: 'es',
      languages: datepickerLocales,
      identificationExpeditionDateText: '',
      identificationExpeditionDatePicker: null,
      expeditionDateOmissionModalActive: false,
      expeditionDateOmissionAccepted: false,
      expeditionDateRequiredSourceLabels: [],
      expeditionDateRequiredSourcesFallback: [
        'Registraduría Nacional del Estado Civil (certificado de estado de cédula de ciudadanía)',
        'RUAF (Registro Único de Afiliados al Sistema de Protección Social)',
        'Delitos sexuales — inhabilidades (Policía Nacional, Ley 1918 de 2018)',
        'Sistema Registro Nacional de Medidas Correctivas RNMC (Policía Nacional)'
      ],
      poligraph: {},
      countries: [],
      cities: [],
      country_id: null,
      dialingCodes: [
          { value: "54", label: "🇦🇷 Argentina (+54)" },
          { value: "591", label: "🇧🇴 Bolivia (+591)" },
          { value: "55", label: "🇧🇷 Brasil (+55)" },
          { value: "56", label: "🇨🇱 Chile (+56)" },
          { value: "57", label: "🇨🇴 Colombia (+57)" },
          { value: "506", label: "🇨🇷 Costa Rica (+506)" },
          { value: "53", label: "🇨🇺 Cuba (+53)" },
          { value: "593", label: "🇪🇨 Ecuador (+593)" },
          { value: "503", label: "🇸🇻 El Salvador (+503)" },
          { value: "502", label: "🇬🇹 Guatemala (+502)" },
          { value: "592", label: "🇬🇾 Guyana (+592)" },
          { value: "509", label: "🇭🇹 Haití (+509)" },
          { value: "504", label: "🇭🇳 Honduras (+504)" },
          { value: "52", label: "🇲🇽 México (+52)" },
          { value: "505", label: "🇳🇮 Nicaragua (+505)" },
          { value: "507", label: "🇵🇦 Panamá (+507)" },
          { value: "595", label: "🇵🇾 Paraguay (+595)" },
          { value: "51", label: "🇵🇪 Perú (+51)" },
          { value: "1", label: "🇺🇸 Estados Unidos (+1)" },
          { value: "1", label: "🇨🇦 Canadá (+1)" },
          { value: "1-787", label: "🇵🇷 Puerto Rico (+1-787)" },
          { value: "1-809", label: "🇩🇴 República Dominicana (+1-809)" },
          { value: "1-876", label: "🇯🇲 Jamaica (+1-876)" },
          { value: "597", label: "🇸🇷 Surinam (+597)" },
          { value: "58", label: "🇻🇪 Venezuela (+58)" },
          { value: "598", label: "🇺🇾 Uruguay (+598)" },
          { value: "590", label: "🇬🇵 Guadalupe (+590)" },
          { value: "596", label: "🇲🇶 Martinica (+596)" },
          { value: "599", label: "🇨🇼 Curazao (+599)" },
          { value: "1-868", label: "🇹🇹 Trinidad y Tobago (+1-868)" },
          { value: "1-758", label: "🇱🇨 Santa Lucía (+1-758)" },
          { value: "1-784", label: "🇻🇨 San Vicente y las Granadinas (+1-784)" },
          { value: "1-473", label: "🇬🇩 Granada (+1-473)" },
          { value: "1-441", label: "🇧🇲 Bermudas (+1-441)" },
          { value: "1-264", label: "🇦🇮 Anguila (+1-264)" },
          { value: "1-340", label: "🇻🇮 Islas Vírgenes de EE. UU. (+1-340)" },
          { value: "1-242", label: "🇧🇸 Bahamas (+1-242)" },
          { value: "1-284", label: "🇻🇬 Islas Vírgenes Británicas (+1-284)" },
          { value: "1-345", label: "🇰🇾 Islas Caimán (+1-345)" },
          { value: "1-649", label: "🇹🇨 Islas Turcas y Caicos (+1-649)" },
          { value: "1-664", label: "🇲🇸 Montserrat (+1-664)" },
          { value: "1-869", label: "🇰🇳 San Cristóbal y Nieves (+1-869)" },
          { value: "1-767", label: "🇩🇲 Dominica (+1-767)" }
        ],
      idTypes: [
        { id: null, label: 'Seleccione una opción' },
        { id: 1, label: 'Cédula' },
        { id: 2, label: 'Tarjeta de identidad' },
        { id: 3, label: 'Pasaporte' },
        { id: 4, label: 'Cédula de extranjería' },
      ],
      educationLevels: [
        { id: null, label: 'Seleccione una opción' },
        { id: 0, label: 'Primaria' },
        { id: 1, label: 'Bachiller' },
        { id: 2, label: 'Profesional Universitario' },
        { id: 3, label: 'Técnico Profesional' },
        { id: 4, label: 'Otro' },
        { id: 5, label: 'Tecnólogo' },
        { id: 6, label: 'Especialista' },
        { id: 7, label: 'Maestria' },
        { id: 8, label: 'Doctorado' }

      ],
      projectTypes: [
        { id: null, label: 'Seleccione una opción' },
        { id: 0, label: 'Visita domiciliaria' },
        { id: 1, label: 'Prueba psicotécnica' },
        { id: 2, label: 'Estudio de seguridad' },
        { id: 3, label: 'Listados de riesgo' },
        { id: 4, label: 'Prueba de poligrafía' },
        { id: 5, label: 'Antecedentes Judiciales' },
        { id: 6, label: 'Visita Domiciliaria Basica' },
        { id: 7, label: 'Academica y Antecedentes' },
        { id: 8, label: 'Verificacion Academica' },
        { id: 9, label: 'Referencias, Academicas y Laborales' },
        { id: 12, label: 'Visita OEA' },
        { id: 15, label: 'Visita teletrabajo completo' }
      ],
      project_id_create: 0,
      dropzoneOptions: {
        url: '',
        thumbnailWidth: 150,
        maxFilesize: 20,
        headers: {},
        dictDefaultMessage: 'Arrastrar y soltar los archivos'
      },
      project_create: false,
      percentajeForm: 0,
      popupActive3: false,
      contact_candidate: true,
      city: '',
      non_valid_message: false,
      non_valid_size: false,
      files: [],
      filesTemplate: [
        {
          id: 0, input_id: 0, name_archive: 'Hoja de vida', name:'Subir Hoja de vida *', name_upload: 'Hoja de vida cargada', content: null
        },
        {
          id: 1, input_id: 1, name_archive: 'Habeas data', name:'Subir Habeas Data *', name_upload: 'Habeas data cargado', content: null
        },
        {
          id: 2, input_id: 2, name_archive: 'Diploma académico', name:'Subir Diploma académico', name_upload: 'Diploma académico cargada', content: null
        },
        {
          id: 2, input_id: 3, name_archive: 'Diploma académico', name:'Subir Diploma académico', name_upload: 'Diploma académico cargada', content: null
        },
        {
          id: 2, input_id: 4, name_archive: 'Diploma académico', name:'Subir Diploma académico', name_upload: 'Diploma académico cargada', content: null
        },
        {
          id: 2, input_id: 5, name_archive: 'Diploma académico', name:'Subir Diploma académico', name_upload: 'Diploma académico cargada', content: null
        },
        {
          id: 3, input_id: 6, name_archive: 'Certificado académico', name:'Subir Certificado académico', name_upload: 'Certificado académico cargado', content: null
        },
        {
          id: 3, input_id: 7, name_archive: 'Certificado académico', name:'Subir Certificado académico', name_upload: 'Certificado académico cargado', content: null
        },
        {
          id: 3, input_id: 8, name_archive: 'Certificado académico', name:'Subir Certificado académico', name_upload: 'Certificado académico cargado', content: null
        },
        {
          id: 3, input_id: 9, name_archive: 'Certificado académico', name:'Subir Certificado académico', name_upload: 'Certificado académico cargado', content: null
        },
        {
          id: 4, input_id: 10, name_archive: 'Certificado laboral', name:'Subir Certificado laboral', name_upload: 'Certificado laboral cargado', content: null
        },
        {
          id: 4, input_id: 11, name_archive: 'Certificado laboral', name:'Subir Certificado laboral', name_upload: 'Certificado laboral cargado', content: null
        },
        {
          id: 4, input_id: 12, name_archive: 'Certificado laboral', name:'Subir Certificado laboral', name_upload: 'Certificado laboral cargado', content: null
        },
        {
          id: 4, input_id: 13, name_archive: 'Certificado laboral', name:'Subir Certificado laboral', name_upload: 'Certificado laboral cargado', content: null
        }
      ]
    }
  },
  methods: {
    publicAssetUrl,
    handleFormFailure() {
      this.formFailed = true;  // Actualiza el estado en el componente padre
    },
    handlePoligraphDateSecondUpdate(updatedDateSecond) {
      this.poligraph.poligraph_sugested_date_second = updatedDateSecond
    },
    handleFormValidityUpdate(isFormValid) {
      this.isFormValid = isFormValid;
    },
    handlePoligraphDateUpdate(updatedDate) {
      this.poligraph.poligraph_sugested_date = updatedDate
    },
    handlePoligraphReasonUpdate(updatedReason) {
      this.poligraph.poligraph_reason = updatedReason
    },
    handlePoligraphyTypeUpdate(updatedType) {
      this.poligraph.poligraph_type = updatedType
    },
    handlePoligraphVirtualUpdate(updatedVirtual) {
      this.poligraph.poligraph_virtual = updatedVirtual
    },
    formatExpeditionDateInput(raw) {
      const digits = String(raw || '').replace(/\D/g, '').slice(0, 8)
      if (!digits) return ''

      if (digits.length <= 2) return digits
      if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
      return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
    },
    normalizeExpeditionDateText(text) {
      const trimmed = String(text || '').trim()
      if (!trimmed) return ''

      const isoMatch = trimmed.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/)
      if (isoMatch) {
        const day = isoMatch[3].padStart(2, '0')
        const month = isoMatch[2].padStart(2, '0')
        const year = isoMatch[1]
        return `${day}/${month}/${year}`
      }

      const digitsOnly = trimmed.replace(/\D/g, '')
      if (digitsOnly.length === 8) {
        return this.formatExpeditionDateInput(digitsOnly)
      }

      return this.formatExpeditionDateInput(trimmed)
    },
    parseDDMMYYYY(text) {
      const trimmed = this.normalizeExpeditionDateText(text)
      if (!trimmed) return null

      const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
      if (!match) return null

      const day = parseInt(match[1], 10)
      const month = parseInt(match[2], 10) - 1
      const year = parseInt(match[3], 10)
      const parsed = new Date(year, month, day)

      if (
        parsed.getFullYear() !== year ||
        parsed.getMonth() !== month ||
        parsed.getDate() !== day
      ) {
        return null
      }

      return parsed
    },
    isSameExpeditionDate(left, right) {
      if (!(left instanceof Date) || !(right instanceof Date)) return false
      if (Number.isNaN(left.getTime()) || Number.isNaN(right.getTime())) return false
      return left.getTime() === right.getTime()
    },
    formatDateDisplay(dateValue) {
      if (!(dateValue instanceof Date) || Number.isNaN(dateValue.getTime())) return ''

      const dd = String(dateValue.getDate()).padStart(2, '0')
      const mm = String(dateValue.getMonth() + 1).padStart(2, '0')
      const yyyy = dateValue.getFullYear()
      return `${dd}/${mm}/${yyyy}`
    },
    onExpeditionDateTextInput(value) {
      const formatted = this.formatExpeditionDateInput(value)
      this.identificationExpeditionDateText = formatted
      this.applyExpeditionDateFromText(formatted)
    },
    onExpeditionDateTextBlur() {
      const formatted = this.formatExpeditionDateInput(this.identificationExpeditionDateText)
      this.identificationExpeditionDateText = formatted
      this.applyExpeditionDateFromText(formatted)
    },
    expeditionDateKeypress(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault()
      }
    },
    onExpeditionDatePaste(event) {
      event.preventDefault()
      const clipboardData = event.clipboardData || window.clipboardData
      const pastedText = clipboardData.getData('text')
      const formatted = this.formatExpeditionDateInput(pastedText)
      this.identificationExpeditionDateText = formatted
      this.applyExpeditionDateFromText(formatted)
    },
    applyExpeditionDateFromText(text = this.identificationExpeditionDateText) {
      const normalized = this.normalizeExpeditionDateText(text)
      if (normalized !== this.identificationExpeditionDateText) {
        this.identificationExpeditionDateText = normalized
      }

      const parsed = this.parseDDMMYYYY(normalized)

      if (parsed) {
        this.project.identification_expedition_date = parsed
        if (!this.isSameExpeditionDate(this.identificationExpeditionDatePicker, parsed)) {
          this.identificationExpeditionDatePicker = parsed
        }
        return
      }

      if (!normalized) {
        this.project.identification_expedition_date = null
        this.identificationExpeditionDatePicker = null
        return
      }

      this.project.identification_expedition_date = null
    },
    onExpeditionDatePicked(date) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return

      const displayValue = this.formatDateDisplay(date)
      this.identificationExpeditionDateText = displayValue
      this.project.identification_expedition_date = date
      if (!this.isSameExpeditionDate(this.identificationExpeditionDatePicker, date)) {
        this.identificationExpeditionDatePicker = date
      }
    },
    hasIdentificationExpeditionDateValue() {
      if (this.parseDDMMYYYY(this.identificationExpeditionDateText)) return true

      const value = this.project.identification_expedition_date
      return value instanceof Date && !Number.isNaN(value.getTime())
    },
    formatDateForApi() {
      const parsedFromText = this.parseDDMMYYYY(this.identificationExpeditionDateText)
      const date = parsedFromText || this.project.identification_expedition_date

      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null

      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    clearIdentificationExpeditionDate() {
      this.identificationExpeditionDateText = ''
      this.identificationExpeditionDatePicker = null
      this.expeditionDateOmissionAccepted = false
      this.$delete(this.project, 'identification_expedition_date')
    },
    focusExpeditionDateInput() {
      const input = document.querySelector('#identificationExpeditionDate input') ||
        document.getElementById('identificationExpeditionDate')
      if (!input) return
      input.scrollIntoView({ behavior: 'smooth', block: 'center' })
      input.focus()
    },
    goToExpeditionDateInput() {
      this.expeditionDateOmissionModalActive = false
      this.$nextTick(() => this.focusExpeditionDateInput())
    },
    continueWithoutExpeditionDate() {
      this.expeditionDateOmissionAccepted = true
      this.expeditionDateOmissionModalActive = false
      this.$refs.wizard.nextTab()
    },
    /** Fecha inválida bloquea; fecha vacía pide confirmación una vez. */
    checkExpeditionDateBeforeContinue() {
      if (!this.requiresAntecedentes) return true

      this.applyExpeditionDateFromText()
      if (this.showInvalidExpeditionDateWarning) {
        this.focusExpeditionDateInput()
        return false
      }
      if (this.hasIdentificationExpeditionDateValue()) return true
      if (this.expeditionDateOmissionAccepted) return true

      this.expeditionDateOmissionModalActive = true
      return false
    },
    ...mapMutations(['changeColumnEvent'],["UPDATE_FAST_TRACKING_PROJECTS", "UPDATE_FAST_TRACKING_PROJECTS_COUNT"]),
    iconItemDocument(file) {
      if (file.content == null) {
        return 'drive_folder_upload'
      } else {
        return 'check'
      }
    },
    onlyNumbers(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onlyNumbersOnPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');
      if (!/^\d+$/.test(pastedText)) {
        event.preventDefault();
      }
    },
    nameItem(file) {
      if (file.content == null) {
        return file.name
      } else {
        return file.name_upload
      }
    },
    colorButtonUpload(file) {
      if (file.content == null) {
        return 'primary'
      } else {
        return 'success'
      }
    },
    onPickFile(typeFileId) {
      const ref = `inputFile${typeFileId}`
      this.$refs[ref][0].click()
    },
    async preChargeFiles(typeFileId) {
      const ref = `inputFile${typeFileId}`
      const file = this.$refs[ref][0].files[0]
      const valid_file = this.checkFile(file.name)
      if (file.size < 2000000) {
        if (valid_file) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const result = await new Promise((resolve) => {
            reader.onload = function() {
              resolve(reader.result)
            };
          })
          this.setContentFile(typeFileId, result, file.name)
        } else {
          this.clearInputsFile(this.files[typeFileId])
        }
      } else {
          this.non_valid_size = true
          setTimeout(() => this.non_valid_size = false, 5000)
          return false
      }
    },
    setContentFile(typeFileId, content, name) {
      this.files.forEach(element => {
        if (element.input_id == typeFileId) {
          element.content = content
          element.name_upload = ''
          element.name_upload = `${this.filesTemplate.filter((fileTemplate) => fileTemplate.input_id == typeFileId)[0].name_archive} (${name})`
        }
      });
    },
    clearInputsFiles() {
      this.files.map((file) => this.clearInputsFile(file));
    },
    clearInputsFile(file) {
      this.files.forEach(element => {
        if (element.input_id == file.input_id) {
          element.content = null
        }
      });
      let ref = `#inputFile${file.input_id}`
      document.querySelector(ref).value = null
    },
    assignFile(type_file){
      let index = this.files.findIndex((file) => file.id === type_file && file.content == null)
      let file = this.files[index]
      this.resetChevrons()
      this.resetAccordions()
      this.onPickFile(file.input_id)
    },
    allowsNewFile(type_file){
      const typeFile = this.typeFiles.findIndex(tp => tp.type_file === type_file)
      const maxUploads = this.typeFiles[typeFile].maxUploads
      let filesUploaded = this.files.filter((file) => file.id === type_file && file.content !== null);
      return filesUploaded.length >= maxUploads
    },
    checkFile(content) {
        const fileElement = content
        let fileExtension = "";
        if (fileElement.lastIndexOf(".") > 0) {
            fileExtension = fileElement.substring(fileElement.lastIndexOf(".") + 1, fileElement.length);
        }
        if (['pdf', 'png', 'jpg', 'jpeg'].includes(fileExtension.toLowerCase())) {
            return true
        }
        else {
            this.non_valid_message = true
            setTimeout(() => this.non_valid_message = false, 5000)
            return false
        }
    },
    goToInstruction() {
      let routeData = this.$router.resolve({ name: 'instruction' });
      window.open(routeData.href, '_blank');
    },
    async getBusinessUnits() {
        try {
            let { client_id } = this.$store.getters.userInfo.user
            let { data } = await this.$http.get(`${ this.url() }api/v1/business_units`, {
                params: {
                    client_id
                }
            })

            this.businessUnits = Array.isArray(data) ? data : []
        } catch (error) {
            console.error(error)
        }
    },
    scrollUp() {
      window.scrollTo(0, 0);
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
              resolve(true)
          } else {
            reject("correct all values");
            this.scrollUp();
          }
        })
      })
    },
    validateStep2() {
      let str = /[^a-zA-Z0-9]/g;
      this.project.person_id = this.project.person_id.replace(str, '')
      const date = new Date().toLocaleString("en-GB", { timeZone: process.env.VUE_APP_TZ })
      this.project.created_at_front = date
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(result => {
          this.businessUnitError = this.hasBusinessUnits && !this.businessUnit
          if (result && !this.businessUnitError && this.productsProject != null) {
            resolve(true)
          } else {
            reject("correct all values");
            this.scrollUp();
          }
        })
      })
    },
    async validateStep3() {
      this.dropzoneOptions.headers = await this.headers()
      return new Promise((resolve, reject) => {
        const requiresPolygraphData = this.productsProject[0] == 4
        const isAdditionalInfoValid = !requiresPolygraphData || this.isFormValid

        if (isAdditionalInfoValid) {
          this.$validator.validateAll("step-3").then(result => {
            if (result && this.checkExpeditionDateBeforeContinue()) {
              resolve(true);
            } else {
              reject("correct all values");
            }
          });
        } else {
          reject("correct all values");
          this.scrollUp();
          this.handleFormFailure();
        }
      })
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-4").then(result => {
          this.garbage = result
          this.popupActive = false;
          this.percentajeForm = 100
        })
        this.garbage = reject
      })
    },
    resetForm() {
        this.contract_id = null
        this.productsProject.splice(0, 1)
        this.businessUnit = ''
        this.businessUnitError = false
    },
    createProject() {
      this.showLoader = true
      let user_id = this.userInfo.user.id
      let current_user = user_id
      let path = "/api/v1/projects"
      this.project.authorize_requesting_documents = this.contact_candidate


      // NOTE: Si el tipo de proyecto es visita
      if ([13, 6, 12, 15, 18].includes(this.productsProject[0])) {
        this.project.virtual = this.projectIsVirtual
      } else {
        delete this.project.virtual
      }

      if (this.hasBusinessUnits && this.businessUnit) {
          this.project.business_unit_id = this.businessUnit
      } else {
          this.$delete(this.project, 'business_unit_id')
      }

      if (this.requiresAntecedentes) {
        this.applyExpeditionDateFromText()
        const expeditionDate = this.formatDateForApi()
        if (expeditionDate) {
          this.project.identification_expedition_date = expeditionDate
          this.$delete(this.project, 'expedition_date_omission_accepted')
        } else {
          this.$delete(this.project, 'identification_expedition_date')
          this.project.expedition_date_omission_accepted = this.expeditionDateOmissionAccepted
        }
      } else {
        this.$delete(this.project, 'expedition_date_omission_accepted')
      }

      if (!this.project_create) {
        let url = this.url() + path
        let creation_request = {}
        if (this.productsProject[0] == 4) {
          creation_request = { project: this.project, current_user: current_user, contract_id: this.contract_id, project_type_id: this.productsProject[0], files: this.files, poligraph: this.poligraph }
        } else {
          creation_request = { project: this.project, current_user: current_user, contract_id: this.contract_id, project_type_id: this.productsProject[0], files: this.files }
        }
        this.requestPost(url, creation_request).then(response => {
          this.project_create = true;
          let message = ""
          if (response.data.response.success == true) {
            this.project_id_create = response.data.response.data.project.id
            this.getProjectsByTypeEvent() // update first column events traceability when create project
            this.setDefaultFiles()
            this.clearInputsFiles()
            message = "Datos guardados."
            this.formComplete()
            this.path = "/api/v1/projects/fast_tracking?page="+1+"&limit="+7+"&query="+''
            this.requestGetWithoutContent(this.url()+this.path, {}).then(response => {
              if(response.data.success == true){
                this.projects = response.data.projects
                this.projectsCount = Math.ceil(response.data.projects_count/7)
              }else{
                console.log("error -> " + response.data.message);
              }
            }, (err) => {
              console.log('err users -> ' +  JSON.stringify(err))
            })
          } else {
            this.percentajeForm = 100
            const r = response.data.response
            message = typeof r.message === 'string' ? r.message : (r.message && r.message.message) || 'No se pudo crear el proceso.'
            this.project_create = false
          }
          this.resetForm()
          this.showLoader = false
          this.$vs.notify({
            title: 'Mensaje de Globalwork',
            text: message,
            color: 'primary',
            position: 'bottom-left'
          })
        }, (err) => {
          this.showLoader = false
          this.garbage = err
          this.percentajeForm = 0

          const res = err.response
          if (res && res.status === 422 && res.data && res.data.response && res.data.response.success === false) {
            const r = res.data.response
            const text = typeof r.message === 'string' ? r.message : (r.message && r.message.message) || 'No se pudo crear el proceso.'
            this.project_create = false
            this.$vs.notify({
              title: 'Restricción de creación',
              text: text,
              color: 'warning',
              position: 'bottom-left',
              time: 9000
            })
            return
          }

          this.resetForm()
          this.formComplete()
          this.$vs.notify({
            title: 'Mensaje de Globalwork',
            text: 'Se ha presentado un error en nuestros servidores. Por favor intenta nuevamente.',
            color: 'danger',
            position: 'bottom-left'
          })
        })
      }
      this.errors.clear();
    },
    getProjectsByTypeEvent() { // update first column events traceability when create project
      const eventType = { id: 0, name: 'request_process' }
      this.requestGetWithoutContent(`${this.url()}api/v1/projects/projects_by_event_type?user_id=${this.userInfo.user.id}&event_type=${eventType.id}&per_page=${this.perPage}&page=${this.page}`, {}).then((response) => {
        this.changeColumnEvent({ event_type: eventType.name, data: response.data })
      })
    },
    formComplete() {
      this.popupActivePopup = false;
      this.$refs.wizard.reset()
      this.project = {}
      this.expeditionDateOmissionAccepted = false
      let element = document.getElementById('inputCity')
      if (element != null) element.value = ''
      this.project_create = false
      this.$router.push('/')
    },
    onlyText(event) {
      let regex = null
      if (this.project.person_id_type != undefined && this.project.person_id_type > 2) {
        regex = new RegExp("^[a-zA-Z0-9]+$")
      } else {
        regex = new RegExp("^[0-9]+$")
      }
      let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key) || (this.project.person_id && this.project.person_id.length >= 15)) {
        event.preventDefault();
        return false;
      }
    },
    containsSpecialChars(input) {
      const specialCharsRegex = /[-!@#$%^&*(),.?":{}|<>/¿;+= ]/;
      return specialCharsRegex.test(input);
    },
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      const updatedValue = (this.project.person_id || '').substr(0, 15) + pastedData;
      if (this.containsSpecialChars(updatedValue) || updatedValue.length > 15) {
        event.preventDefault();
        return false;
      }
    },
    regExpressionText(event) {
      let regex = new RegExp("^[a-zA-ZÀ-ÿ ]")
      let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    regExpressionTextNumbers(event) {
      let regex = new RegExp("^[a-zA-ZÀ-ÿ0-9+\\s!\"#$%&'()*+,-./:;=¡¿?@[\\]^_`{|}~]*$")
      let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    validateFileType(file) {
      let files = []
      files.push(file)
      let typeAllowFiles = ["image/png", "image/jpg", "image/jpeg", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ]
      let result = this.validateMimetypes(files, typeAllowFiles)
      if (!result) {
        this.$refs.myVueDropzoneFiles.removeFile(file)
      }
    },
    async send_form(project) {
      if (this.productsProject[0] == 16) {
        const result = await this.requestGet(this.urlPdfGenerator() + '/send_form', {
          project_id: project
        })
      }
    },
    notifyUpload() {
      this.$vs.notify({
        title: 'Mensaje de Globalwork',
        text: 'El archivo se ha subido correctamente',
        color: 'primary',
        position: 'bottom-left'
      })

    },
    setAuthorizeContact() {
      let contact_candidate = window.localStorage.getItem('contact_candidate')
      if (contact_candidate == "true") {
        this.contact_candidate = true
      } else {
        console.log(contact_candidate)
      }
    },
    async loadExpeditionDateRequiredSources() {
      try {
        const result = await this.requestGetWithoutContent(
          `${this.url()}api/v1/projects/expedition_date_required_sources`,
          {}
        )
        const labels = result.data && result.data.labels
        if (Array.isArray(labels) && labels.length) {
          this.expeditionDateRequiredSourceLabels = labels
          return
        }
      } catch (error) {
        console.warn('No se pudieron cargar fuentes que requieren fecha de expedición', error)
      }
      this.expeditionDateRequiredSourceLabels = [...this.expeditionDateRequiredSourcesFallback]
    },
    async getCountries() {
      const axios = require('axios')
      try {
        let url = this.url() + 'api/v1/countries'
        let result = await this.requestGetWithoutContent(url, {})
        this.countries = result.data
        this.country_id = 1
      } catch (error) {
        console.log(error)
      }
    },
    async getCities() {
      try {
        let url = this.url() + `api/v1/cities/?country_id=${this.country_id}`
        let result = await this.requestGetWithoutContent(url, {})
        this.cities = result.data
      } catch (error) {
        console.log(error)
      }
    },
    deleteText() {
      if (this.city.length > 0) {
        this.city = this.city.slice(0, -1)
      }
      if (typeof(this.city) == "number") {
        this.city = ""
      }
    },
    setDefaultFiles() {
      this.files = this.filesTemplate
    },
    toggleAccordion(index, mustDisplay) {
      for (let i = 0; i <= 4; i++) {
        const content = document.getElementById(`content${i}`);
        const chevron = document.getElementById(`chevron${i}`);
        if (i === index) {
          if (mustDisplay) {
              chevron.textContent = 'expand_less';
              content.style.display = 'block';
          } else {
              chevron.textContent = chevron.textContent === 'expand_less' ? 'expand_more' : 'expand_less';
              content.style.display = content.style.display === 'none' ? 'block' : 'none';
          }
        } else {
          chevron.textContent = 'expand_more';
          content.style.display = 'none';
        }
      }
    },
    noFilesAdded(type_file){
      let files = this.files.filter(file => file.id === type_file )
      return files.every(file => file.content == null)
    },
    resetChevrons() {
      for (let i = 0; i <= 4; i++) {
        const chevron = document.getElementById(`chevron${i}`);
        chevron.textContent = 'expand_more';
      }
    },
    resetAccordions() {
      for (let i = 0; i <= 4; i++) {
        const content = document.getElementById(`content${i}`);
        content.style.display = 'none';
      }
    }
  },
  mounted() {
    this.project_create = false;
    this.setAuthorizeContact()
    this.setDefaultFiles()
    this.resetChevrons()
    this.resetAccordions()
    this.toggleAccordion()
    this.getBusinessUnits()
    this.loadExpeditionDateRequiredSources()
  },
  created() {
    this.getCountries()
  },
  watch: {
    businessUnit() {
      if (this.businessUnit) {
        this.businessUnitError = false
      }
    },
    country_id() {
      this.getCities()
    },
    assignment_types: function() {
      if (this.assignment_types != null) {
        var assignments_attributtes = []
        this.assignment_types.forEach(assignment_type => {
          assignment_type.assignment_types.forEach(at => {
            assignments_attributtes.push({ "id": at })
          });
          assignments_attributtes.push({ "project_type_id": assignment_type.project_type_id })
        });
        this.assignments = assignments_attributtes
      }
    },
    type_file(val) {
      if (this.dropzoneOptions.url.includes('type_file')) {
        let newUrl = this.dropzoneOptions.url.replace(this.dropzoneOptions.url.split('&')[1], `type_file=${val}`)
        this.$refs.myVueDropzoneFiles.options.url = newUrl
        this.$refs.myVueDropzoneFiles.dropzone.options.url = newUrl
        this.dropzoneOptions.url = newUrl
      } else {
        this.dropzoneOptions.url += `&type_file=${val}`
      }
    },
    'project.person_id_type': function (newValue) {
      if (newValue < 2) {
        this.$nextTick(() => {
        this.$validator.validate('project.person_id');
        });
      }
    },
    productsProject(newValue) {
      if ([13, 6, 12, 15, 18].includes(newValue ? newValue[0] : null)) {
        this.projectIsVirtual = null;
      }
      const typeId = newValue ? newValue[0] : null
      if (typeId == null || !this.antecedentesProjectTypeIds.includes(typeId)) {
        this.clearIdentificationExpeditionDate()
      }
    },
    identificationExpeditionDateText(text) {
      // Si el cliente vuelve a escribir una fecha, la aceptación anterior deja de aplicar.
      if (text && text.trim()) this.expeditionDateOmissionAccepted = false
    },
    identificationExpeditionDatePicker(date) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return

      const displayValue = this.formatDateDisplay(date)
      if (
        this.identificationExpeditionDateText === displayValue &&
        this.isSameExpeditionDate(this.project.identification_expedition_date, date)
      ) {
        return
      }

      this.onExpeditionDatePicked(date)
    }
  },
  components: {
    vSelect,
    FormWizard,
    TabContent,
    Datepicker,
    vueDropzone: vue2Dropzone,
    'products': Products,
    'PoligraphyCards': PoligraphyCards,
    Select,
    Loader
  },
  computed: {
    ...mapGetters(['userInfo'],['fastTrackingProjects', 'fastTrackingProjectsCount']),

    projects:{
      get(){
        return this.$store.state.fastTrackingProjects
      },
      set(val){
        this.$store.dispatch("updateFastTrackingProjects", val);
      }
    },
    projectsCount:{
      get(){
        return this.$store.state.fastTrackingProjectsCount
      },
      set(val){
        this.$store.dispatch("updateFastTrackingProjectsCount", val);
      }
    },

    hasBusinessUnits() {
      return this.realBusinessUnits.length > 0
    },

    realBusinessUnits() {
      if (!Array.isArray(this.businessUnits)) return []
      return this.businessUnits.filter(unit => unit && unit.id !== '' && unit.id != null)
    },

    businessUnitOptions() {
      if (!this.hasBusinessUnits) return []
      return [{ id: '', name: 'Selecciona una opción' }, ...this.realBusinessUnits]
    },

    /** Alineado con Project#need_antecedentes? en gw-clients-api */
    requiresAntecedentes() {
      return this.productsProject != null &&
        this.antecedentesProjectTypeIds.includes(this.productsProject[0])
    },

    showMissingExpeditionDateWarning() {
      if (!this.requiresAntecedentes) return false
      return !this.identificationExpeditionDateText.trim()
    },

    showInvalidExpeditionDateWarning() {
      if (!this.requiresAntecedentes) return false
      if (!this.identificationExpeditionDateText.trim()) return false
      return !this.hasIdentificationExpeditionDateValue()
    },

    /** Ocultar data crédito en estos tipos de proceso */
    hideDatacredit() {
      if (this.productsProject && [3, 19].includes(this.productsProject[0])) {
        this.$set(this.project, 'credit_validation', true)
        return true
      }
      return false
    },

    showCreditValidationSection() {
      return (
        this.productsProject !== null &&
        this.productsProject[0] !== 3 &&
        this.hideDatacredit === false
      )
    },

    popupActivePopup: {
      get() {
        return this.popupActive
      },
      set(val) {
        this.$emit('update:popupActive', val)
      }
    }
  }
}
</script>

<style scoped>
.step-additional-info {
  max-width: 920px;
  margin: 0 auto;
  padding: 8px 4px 24px;
}

.step-additional-info__intro {
  margin-bottom: 24px;
  padding: 18px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f4fc 0%, #f3f6fb 100%);
  border: 1px solid rgba(95, 0, 143, 0.12);
}

.step-additional-info__intro-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #3c1a4e;
}

.step-additional-info__intro-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #5e5873;
}

.step-additional-info__section {
  margin-bottom: 20px;
}

.additional-info-card {
  margin-bottom: 20px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  box-shadow: 0 2px 8px rgba(60, 26, 78, 0.06);
  overflow: hidden;
}

.additional-info-card--accent {
  border-color: rgba(95, 0, 143, 0.18);
  background: linear-gradient(180deg, #faf7fd 0%, #fff 100%);
}

.additional-info-card__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px 0;
}

.additional-info-card__header--spread {
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
}

.additional-info-card__header-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.additional-info-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f2edfc;
  color: #5f008f;
}

.additional-info-card__icon--accent {
  background: rgba(95, 0, 143, 0.12);
}

.additional-info-card__heading {
  flex: 1;
  min-width: 0;
}

.additional-info-card__title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #3c1a4e;
  line-height: 1.3;
}

.additional-info-card__subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #6e6b7b;
}

.additional-info-card__brand-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-left: 12px;
}

.additional-info-card__body {
  padding: 16px 20px 20px;
}

.additional-info-field__label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #3c1a4e;
}

.additional-info-field__optional {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7367f0;
  background: rgba(115, 103, 240, 0.1);
  padding: 2px 8px;
  border-radius: 999px;
}

.additional-info-field__recommended {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #c46a12;
  background: #fff4e8;
  padding: 2px 8px;
  border-radius: 999px;
}

.additional-info-checkbox-row {
  padding: 4px 0;
}

.additional-info-checkbox-row ::v-deep .vs-checkbox-label {
  font-size: 14px;
  line-height: 1.45;
  color: #3c1a4e;
}

.additional-info-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0;
}

.additional-info-radio-group ::v-deep .vs-radio--label,
.additional-info-radio-group ::v-deep .con-vs-radio {
  font-size: 14px;
  line-height: 1.45;
  color: #3c1a4e;
}

.additional-info-field--indented {
  padding-left: 12px;
  border-left: 3px solid rgba(95, 0, 143, 0.25);
}

.additional-info-textarea ::v-deep textarea {
  min-height: 100px;
  font-size: 14px;
  line-height: 1.5;
}

.additional-info-char-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #9a9aaf;
}

.additional-info-cost-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 16px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid rgba(95, 0, 143, 0.2);
  background: rgba(95, 0, 143, 0.06);
  font-size: 13px;
  line-height: 1.5;
  color: #4a4a68;
}

.additional-info-cost-notice__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #5f008f;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.additional-info-cost-notice strong {
  font-weight: 600;
  color: #3c1a4e;
}

.expedition-date-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 768px) {
  .expedition-date-layout {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
  }
}

.expedition-date-layout__calendar {
  justify-self: start;
}

.expedition-date-picker--inline ::v-deep .vdp-datepicker__calendar {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 8px;
  width: 100%;
  max-width: 320px;
}

.expedition-date-calendar-label {
  color: #626262;
  line-height: 1.4;
  margin-bottom: 6px;
}

.expedition-date-help {
  color: #626262;
  line-height: 1.4;
}

.expedition-date-warning {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #ff9f43;
  background: #fff4e8;
  color: #5e5873;
}

.expedition-date-warning__icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff9f43;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.expedition-date-warning__body {
  flex: 1;
  min-width: 0;
}

.expedition-date-warning__text {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.45;
}

.expedition-date-warning__text:last-child {
  margin-bottom: 0;
}

.expedition-date-warning__sources {
  margin: 0;
  padding-left: 1.15rem;
  font-size: 13px;
  line-height: 1.5;
  color: #4a4a68;
}

.expedition-date-warning__sources li {
  margin-bottom: 6px;
}

.expedition-date-warning__sources li:last-child {
  margin-bottom: 0;
}

.expedition-date-warning__cta {
  margin: 10px 0 0;
  font-weight: 600;
}

.expedition-date-omission {
  position: relative;
  padding: 28px 28px 24px;
  color: #5e5873;
}

.expedition-date-omission__close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #9a97a6;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.expedition-date-omission__close:hover,
.expedition-date-omission__close:focus-visible {
  background: #f3f2f7;
  color: #5e5873;
  outline: none;
}

.expedition-date-omission__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: #fff4e8;
  color: #ff9f43;
}

.expedition-date-omission__title {
  margin: 0 0 8px;
  padding-right: 24px;
  font-size: 19px;
  font-weight: 600;
  line-height: 1.3;
  color: #2c2a3a;
}

.expedition-date-omission__lead {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.5;
}

.expedition-date-omission__sources {
  margin: 0 0 16px;
  padding: 14px 16px;
  list-style: none;
  border: 1px solid #ffe0bf;
  border-radius: 10px;
  background: #fffaf4;
}

.expedition-date-omission__source {
  position: relative;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.45;
  color: #4a4a68;
}

.expedition-date-omission__source + .expedition-date-omission__source {
  margin-top: 8px;
}

.expedition-date-omission__source::before {
  content: '';
  position: absolute;
  top: 0.5em;
  left: 2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff9f43;
}

.expedition-date-omission__hint {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: #2c2a3a;
}

.expedition-date-omission__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.expedition-date-omission__button {
  min-width: 170px;
}

@media (max-width: 480px) {
  .expedition-date-omission {
    padding: 24px 20px 20px;
  }

  .expedition-date-omission__actions {
    flex-direction: column-reverse;
  }

  .expedition-date-omission__button {
    width: 100%;
  }
}

.expedition-date-error {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #ea5455;
  background: #fceaea;
  color: #5e5873;
}

.expedition-date-error__icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ea5455;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.expedition-date-error__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
}

.title-bar{
  border-radius: 8px;
  background: #F2EDFC;
  padding: 10px;
}
.form-labels{
  font-size: 16px;
  padding-bottom: 10px;
  font-weight: 500;
  color: #3C1A4E;
}
.custom-title{
  color:#5F008F;
  font-family: Montserrat;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
}

.custom-title.subtitle{
  color: #3C1A4E;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 16px;
}

.new-feature {
  color: rgb(95, 0, 145);
  font-size: 20px;
  font-weight: 600;
}

.read-more {
  margin-left: 0.5rem;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}

.select {
  height: 38px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: none;
  color: inherit;
  font-size: 1rem;
  padding: 5px;
  border-radius: 4px;
  -webkit-appearance: textfield;
  background-color: white;
}

.files-candiate {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.list-documents {
  width: 50%;
}

.item-document {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 32px;
}

.item-icon {
  vertical-align: sub;
  font-size: 15px;
}

.color-purple {
  color: #5F008F;
}

.color-green {
  color: #00AF50;
}

.icon-add {
  color: #5F008F;
  padding: 5px 7px !important;
  margin: 0px 5px !important;
  height: 100%;
}

.icon-add:hover {
  border-radius: 5px;
  height: 100%;
}

.vs-list--slot {
  position: relative;
  right: 200%;
}

.loader-create {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.accordion-header {
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    padding: 5px;
}

.accordion-content {
  display: none;
  border: none;
  /* padding: 10px; */
  margin: 0 15px;
}

.filter-input {
  width: 100%;
}

.extension-error{
  color: #3C1A4E;
  margin: 7px 20px 25px;
  font-weight: 600;
}

.extension-message{
  text-align: center;
}

.max-upload {
  color: #3C1A4E;
  font-size: 10px;
}

.added-file{
  padding: 5px;
}

.text-size{
  font-size: 13px;
}

.column {
  width: 45%;
}

.column-2 {
  width: 45%;
  align-content: left;
}

.no-added-files {
  font-size: 12px;
  color: #3C1A4E;
  padding: 5px;
}


</style>

<style>
/*
 * Sin scoped: la caja del vs-popup no recibe el atributo de este componente.
 * Otros componentes fijan .vs-popup { width: 80% !important } de forma global,
 * por eso el ancho necesita !important y un selector más específico.
 */
.expedition-date-omission-popup .vs-popup {
  width: 560px !important;
  max-width: calc(100% - 32px);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(44, 42, 58, 0.22);
}

.expedition-date-omission-popup .vs-popup--header {
  display: none;
}

.expedition-date-omission-popup .vs-popup--content {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
